import { formatDocument } from "../../../utils/utils";

const ParticipacaoEmEmpresas = ({
  empresas,
  hasStatus: statusEnabled = false,
  hasNegative: negativeEnabled = false,
}) => {
  const isEmpty = (val) => val == null || val === "" || val === "-";

  const hasEntrada = empresas?.some((e) => !isEmpty(e?.dataEntrada));
  const hasFuncao = empresas?.some((e) => !isEmpty(e?.funcao));
  const hasParticipacao = empresas?.some(
    (e) =>
      !isEmpty(e?.participacaoEmPorcentagem) ||
      !isEmpty(e?.percentualParticipacao)
  );
  const hasStatus =
    statusEnabled && empresas?.some((e) => !isEmpty(e?.status));
  const hasNegative =
    negativeEnabled && empresas?.some((e) => e?.temRestricao != null);

  const colCount =
    2 + // Empresa (col-span-2)
    (hasEntrada ? 1 : 0) +
    (hasFuncao ? 1 : 0) +
    (hasParticipacao ? 1 : 0) +
    (hasStatus ? 1 : 0) +
    (hasNegative ? 1 : 0);

  const gridStyle = {
    gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))`,
  };

  return (
    <>
      <div className="mt-3 overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <div className="border-b border-slate-200 bg-slate-50 px-4 py-3">
          <div
            className="grid gap-3 text-[10px] font-semibold uppercase tracking-[0.28em] text-slate-500"
            style={gridStyle}
          >
            <div className="col-span-2">Empresa</div>
            {hasEntrada && <div className="text-center">Entrada</div>}
            {hasFuncao && <div className="text-center">Função</div>}
            {hasParticipacao && <div className="text-center">Part. (%)</div>}
            {hasStatus && <div className="text-center">Status</div>}
            {hasNegative && <div className="text-center">Tem restrição?</div>}
          </div>
        </div>

        {empresas?.length > 0 && (
          <div className="divide-y divide-slate-100">
            {empresas?.map((empresa, index) => (
              <div
                key={index}
                className={`grid gap-3 px-4 py-3 text-sm items-center ${
                  index % 2 === 0 ? "bg-white" : "bg-slate-50/40"
                } hover:bg-slate-50`}
                style={gridStyle}
              >
                <div className="col-span-2">
                  <div className="font-medium text-slate-900">
                    {empresa?.empresa || "-"}
                  </div>
                  <div className="text-[11px] text-slate-500">
                    CNPJ:{" "}
                    {empresa?.cnpj ? formatDocument(empresa?.cnpj) : "-"}
                  </div>
                </div>
                {hasEntrada && (
                  <div className="text-center text-slate-700">
                    {empresa?.dataEntrada || "-"}
                  </div>
                )}
                {hasFuncao && (
                  <div className="text-center text-slate-700">
                    {empresa?.funcao || "-"}
                  </div>
                )}
                {hasParticipacao && (
                  <div className="text-center text-slate-700">
                    {empresa?.participacaoEmPorcentagem ||
                      empresa?.percentualParticipacao ||
                      "-"}
                  </div>
                )}
                {hasStatus && (
                  <div className="text-center text-slate-700">
                    {empresa?.status || "-"}
                  </div>
                )}
                {hasNegative && (
                  <div className="text-center text-slate-700">
                    {empresa?.temRestricao ? "Sim" : "Não"}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default ParticipacaoEmEmpresas;
